import { useEffect, useState } from "react";
import { useParams} from "react-router-dom";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { getBlogPost } from "@/lib/api";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { getBlogPost(slug).then(setPost).catch(() => setPost(false)); }, [slug]);

  if (post === false) return <div className="pt-40 pb-24 text-center text-sage-300">Article not found. <a href="/resources" className="text-golden-500">Back to resources</a></div>;
  if (!post) return <div className="pt-40 pb-24 text-center text-sage-300"><Loader2 className="h-6 w-6 animate-spin mx-auto" /></div>;

  return (
    <div data-testid="blog-post-page" className="pt-32">
      <article className="max-w-3xl mx-auto px-6 lg:px-10 py-12">
        <a href="/resources" className="inline-flex items-center gap-2 text-sage-300 hover:text-golden-500 transition-colors duration-300 mb-10">
          <ArrowLeft className="h-4 w-4" /> All resources
        </a>
        <Reveal>
          <div className="flex items-center gap-3 mb-5 text-sm">
            <span className="uppercase tracking-wider text-golden-500 font-semibold">{post.category}</span>
            <span className="text-sage-400">{post.read_time}</span>
          </div>
          <h1 className="font-serif text-4xl md:text-6xl text-sage-100 leading-tight mb-8">{post.title}</h1>
          <div className="aspect-[16/9] rounded-sm overflow-hidden border border-forest-700 mb-10">
            <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="prose prose-invert max-w-none">
            {post.body.split("\n\n").map((para, i) => (
              <p key={i} className="text-sage-200 text-lg leading-relaxed mb-6">{para}</p>
            ))}
          </div>
        </Reveal>
        <div className="border-t border-forest-700 mt-14 pt-10">
          <a href="/contact" data-testid="post-cta" className="group inline-flex items-center gap-2 bg-golden-500 text-navy font-semibold px-8 py-4 rounded-sm transition-colors duration-300 hover:bg-golden-600">
            Talk to Susan about this <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>
      </article>
    </div>
  );
};

export default BlogPost;
